import constants from './constants';

export const getProductSelectValues = (translation) => {
    const { productSelectValues } = constants;
    return productSelectValues.map(id => (
        { id, text: translation.PRODUCT_KEYS[id] }
    ));
};

export const getSourceSelectValues = (translation) => {
    const { sources } = constants;
    return sources.map(id => (
        { id, text: translation.SOURCE_KEYS[id] }
    ));
};

export const getPageSelectValues = (translation) => {
    const { pages } = constants;
    return pages.map(id => (
        { id, text: translation.PAGE_KEYS[id] }
    ));
};

export default {
    getProductSelectValues,
    getSourceSelectValues,
    getPageSelectValues,
};
